import React from 'react'
import SonographyDrawer from '../../components/drawers/sonography'
import BilledQueue from '../../components/pages/billedQueue'

const Queue = () => {
    return (
        <BilledQueue
            category="Sonography"
            basePath="/app/sonography/queue"
            DrawerComponent={SonographyDrawer}
            requestDepartment="sonography"
        />
    )
}

export default Queue
